import { useAuth } from "./useAuth";
import { useLocation, useSearchParams } from "react-router-dom";
import { BROKER_DESK } from "../api/brokerDesk";
import { useBrokerDesk } from "./useBrokerDesk";

export function useAgentScope() {
  const { session } = useAuth();
  const [params] = useSearchParams();
  const { pathname } = useLocation();
  const { mode } = useBrokerDesk();
  const as = params.get("as");
  const onBroker = pathname.startsWith("/broker");
  const mine = onBroker && mode === BROKER_DESK.mine;

  if (session?.role === "admin") {
    if (onBroker) {
      return {
        session,
        writeAgentId: as || session.userId,
        listAgentId: as || (mine ? session.userId : undefined),
        excludeAgentId: as || mine ? undefined : session.userId,
        previewing: true,
        previewId: as || (mine ? "mine" : "office"),
      };
    }
    const previewId = as || "agent-demo";
    return {
      session,
      writeAgentId: previewId,
      listAgentId: previewId,
      excludeAgentId: undefined,
      previewing: true,
      previewId,
    };
  }

  if (session?.role === "broker") {
    return {
      session,
      writeAgentId: session.userId,
      listAgentId: mine ? session.userId : undefined,
      excludeAgentId: mine ? undefined : session.userId,
      previewing: false,
      previewId: mine ? "mine" : "office",
    };
  }

  const id = session?.userId || "agent-demo";
  return {
    session,
    writeAgentId: id,
    listAgentId: id,
    excludeAgentId: undefined,
    previewing: false,
    previewId: id,
  };
}
